module.exports = __webpack_public_path__ + "img/logo.a3f83c17.png";